import { useDispatch, useSelector } from 'react-redux';
import { modalActions } from '../../store/modal-slice';
import { useTranslation } from 'react-i18next';

import classes from './MainHeader.module.scss';

import Sider from '../Sider/Sider';
import HeaderLeft from './HeaderLeft';
import HeaderRight from './HeaderRight';
import LogMenu from '../Auth/LogMenu';

import useSider from '../Sider/useSider';

export default function MainHeader() {
  const { t } = useTranslation('mainpage');

  const dispatch = useDispatch();
  const { isSignupModalOpen, isLoginModalOpen } = useSelector(
    (state) => state.modal
  );

  const [
    isSiderVisible,
    isSiderClosing,
    closeSiderWithAnimation,
    siderModalToggled,
  ] = useSider();

  const closeModal = () => {
    dispatch(modalActions.closeModal());
  };

  const openLoginModal = () => {
    dispatch(modalActions.openLoginModal());
  };

  const openSignupModal = () => {
    dispatch(modalActions.openSignupModal());
  };

  return (
    <>
      {isSignupModalOpen && (
        <LogMenu closeModal={closeModal} initialSignup={true} />
      )}
      {isLoginModalOpen && (
        <LogMenu closeModal={closeModal} initialSignup={false} />
      )}
      {isSiderVisible && <Sider isClosing={isSiderClosing} />}
      <header className={classes['main-header']}>
        <HeaderLeft
          toggleSider={closeSiderWithAnimation}
          isSiderVisible={siderModalToggled}
        />
        <HeaderRight
          t={t}
          openLoginModal={openLoginModal}
          openSignupModal={openSignupModal}
        />
      </header>
    </>
  );
}
